import { render } from "./IncidentHeader.vue?vue&type=template&id=0b488fa1&scoped=true"
import script from "./IncidentHeader.vue?vue&type=script&lang=js"
export * from "./IncidentHeader.vue?vue&type=script&lang=js"

import "./IncidentHeader.vue?vue&type=style&index=0&id=0b488fa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b488fa1"]])

export default __exports__